import React from "react";
import { Toaster } from "react-hot-toast";
import GlobalStyles from "styles/GlobalStyles";

import ComponentRenderer from "ComponentRenderer.js";
import ThankYouPage from "pages/public/ThankYouPage";

import HomePage from "pages/public/HomePage";
import AboutPage from "pages/public/AboutPage";
import ServicesPage from "pages/public/ServicesPage";
import DestinationsPage from "pages/public/DestinationsPage";
import ContactPage from "pages/public/ContactPage";
import VerifyPage from "pages/public/VerifyPage";
import PrivacyPage from "pages/public/PrivacyPage";
import CgvPage from "pages/public/CgvPage";

import LoginPage from "pages/auth/LoginPage";
import RegisterPage from "pages/auth/RegisterPage";
import ForgotPasswordPage from "pages/auth/ForgotPasswordPage";

import DashboardPage from "pages/dashboard/DashboardPage";
import ProceduresPage from "pages/dashboard/ProceduresPage";
import DocumentsPage from "pages/dashboard/DocumentsPage";
import AttestationsPage from "pages/dashboard/AttestationsPage";
import ProfilePage from "pages/dashboard/ProfilePage";
import MessagesPage from "pages/dashboard/MessagesPage";
import NotificationsPage from "pages/dashboard/NotificationsPage";

import PrivateRoute from "components/common/PrivateRoute";
import { AuthProvider } from "contexts/AuthContext";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ROUTES } from "constants/routes";

export default function App() {
  return (
    <>
      <GlobalStyles />
      <Toaster position="top-right" toastOptions={{ duration: 4000 }} />
      <Router>
        <AuthProvider>
          <Routes>
            {/* ── MomsEduc Study — public ── */}
            <Route path={ROUTES.HOME} element={<HomePage />} />
            <Route path={ROUTES.ABOUT} element={<AboutPage />} />
            <Route path={ROUTES.SERVICES} element={<ServicesPage />} />
            <Route path="/services/:slug" element={<ServicesPage />} />
            <Route path="/destinations" element={<DestinationsPage />} />
            <Route path="/destinations/:code" element={<DestinationsPage />} />
            <Route path={ROUTES.CONTACT} element={<ContactPage />} />
            <Route path={ROUTES.VERIFY_AVI} element={<VerifyPage />} />

            {/* ── MomsEduc Study — légal ── */}
            <Route path={ROUTES.PRIVACY_POLICY} element={<PrivacyPage />} />
            <Route path={ROUTES.CGV} element={<CgvPage />} />

            {/* ── MomsEduc Study — auth ── */}
            <Route path={ROUTES.LOGIN} element={<LoginPage />} />
            <Route path={ROUTES.REGISTER} element={<RegisterPage />} />
            <Route
              path={ROUTES.FORGOT_PASSWORD}
              element={<ForgotPasswordPage />}
            />

            {/* ── Student portal ── */}
            <Route
              path={ROUTES.STUDENT_DASHBOARD}
              element={
                <PrivateRoute>
                  <DashboardPage />
                </PrivateRoute>
              }
            />
            <Route
              path={ROUTES.STUDENT_PROCEDURES}
              element={
                <PrivateRoute>
                  <ProceduresPage />
                </PrivateRoute>
              }
            />
            <Route
              path={`${ROUTES.STUDENT_PROCEDURES}/:id`}
              element={
                <PrivateRoute>
                  <ProceduresPage />
                </PrivateRoute>
              }
            />
            <Route
              path={ROUTES.STUDENT_DOCUMENTS}
              element={
                <PrivateRoute>
                  <DocumentsPage />
                </PrivateRoute>
              }
            />
            <Route
              path={ROUTES.STUDENT_ATTESTATIONS}
              element={
                <PrivateRoute>
                  <AttestationsPage />
                </PrivateRoute>
              }
            />
            <Route
              path={ROUTES.STUDENT_PROFILE}
              element={
                <PrivateRoute>
                  <ProfilePage />
                </PrivateRoute>
              }
            />
            <Route
              path={ROUTES.STUDENT_MESSAGES}
              element={
                <PrivateRoute>
                  <MessagesPage />
                </PrivateRoute>
              }
            />
            <Route
              path={ROUTES.STUDENT_NOTIFICATIONS}
              element={
                <PrivateRoute>
                  <NotificationsPage />
                </PrivateRoute>
              }
            />

            {/* ── Template demo routes (dev only) ── */}
            <Route
              path="/components/:type/:subtype/:name"
              element={<ComponentRenderer />}
            />
            <Route
              path="/components/:type/:name"
              element={<ComponentRenderer />}
            />
            <Route path="/thank-you" element={<ThankYouPage />} />
          </Routes>
        </AuthProvider>
      </Router>
    </>
  );
}
